<template>
  <div id="glossary">
    <h1>セットの出身地</h1>
    <span class="md-subheading">
      そのセットはどこの地方のもの？
    </span>

    <br /><br />

    <span class="md-body-1">
      Clare Lancers Set、Connemara Set、West Kerry Set...土地の名前が付いているセットは数ありますが、よく踊っているセットが一体どこの地方のものなのか、気になったことはありませんか？<br /><br />
      このページではSetDancePalで掲載されているセットの発祥をGoogle Mapのマイマップにマッピングしています。<br /><br />
      たとえば、Clare Lancers Set, Kilfenora SetなどはClare州のセット。Connemara Set, Claddagh SetはGalway州のセット。Baile Bhuirne Jig SetはCork州のセットです。<br /><br />
      セットの名前を聞いてピンときた方もいるかもしれませんが、Clare州ではReelのセットが多く、Cork州などのアイルランド南部ではBaile Bhuirne Jig SetやSliabh Luachra SetなどPolka/Slideのセットが多いです。<br /><br />
      地方毎に異なる動きやステップ、フィガーの特徴がわかるようになるとセットダンスを踊るのがもっと楽しくなるかも??
    </span>

    <h2>使い方</h2>
    <md-list>
      <md-list-item>
        <span>
          ・地図の右上にあるカギ括弧で囲まれているアイコンを押してください。Google Mapが開きます
        </span>
      </md-list-item>
      <md-list-item>
        <span>
          ・「アイルランドの定番セット」ではケーリーでよく取り上げられるセットが閲覧できます
        </span>
      </md-list-item>
      <md-list-item>
        <span>
          ・「アイルランドのマニアックなセット」ではPat Murphyさんがワークショップなどで教えているセットなどの出身地が閲覧できます
        </span>
      </md-list-item>
      <md-list-item>
        <span>
          ・「アイルランド以外のセット」ではアイルランド以外の国で作られたセットの出身地が閲覧できます。
        </span>
      </md-list-item>
    </md-list>

    <br />

    <div class="map">
      <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1rUxQdv3iLOHd6gPJ2Trm-kKlK5yK3-av&z=5" width="640" height="480"></iframe>
    </div>

    <br />

    <span class="md-caption">
      マッピングはPat Murphy氏の本やインターネットを用いて調査を行いましたが誤りがあるかもしれません。誤りを見つけられた方は城までご連絡ください。セットの豆知識などのご意見も歓迎です。
    </span>

    <h3>出自のわからないセット</h3>
    <span class="md-body-1">
      ・Cavan Reel Set<br /><br />
      ご存じの方がおりましたら教えてください
    </span>

    <md-divider></md-divider>

    <span class="md-caption">copyright © 2017-{{ new Date().getFullYear() }} Hiroshi Jo</span>

  </div>
</template>

<script>
// import db from '../db'

export default {
  name: 'set',
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

.map {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding-top: 56.25%;
}
.map iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// SetMap.vue?0bb3f304